import { useState, useEffect } from 'react';
import DataGrid, {
    Column,
    FilterRow,
    HeaderFilter,
    Pager,
    Paging
} from 'devextreme-react/data-grid';
import { PagePrincipal } from '../../containers';
import { useTranslation } from 'react-i18next';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.css';
import { getMyNotifications } from '../../api/notifications';
import { NotificationDto } from '../../dto/notificationDto';
import RouteNavigation from '../../constants/RouteNavigation';
import { useHistory } from 'react-router-dom';
const allowedPageSizes = [5, 10, 50, 100];

const Notifications = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [notifications, setNotifications] = useState<NotificationDto[] | undefined>([]);
  
    useEffect(() => {
        const fetch = async () => {
          const data = await getMyNotifications();
          setNotifications(data || []);
        }
        fetch();
    }, [setNotifications]);

    const handleClickDocRad = (url: string) => {
        if (url) history.push(`/${url}`);
    }

    const renderGridCellDocRad = (data: any) => {
        const { data: { originalDocRad } } = data;
        return (
            <p
                onClick={() => handleClickDocRad(`${RouteNavigation.pqrsTrackingDocument}/${originalDocRad}`)}
                className="text-blue-400 hover:text-blue-500 cursor-pointer"
            >
                {originalDocRad}
            </p>
        );
    }

    return (
        <PagePrincipal title={t('pages.notifications.title')}>
            <DataGrid
                dataSource={notifications}
                columnAutoWidth={true}
                allowColumnResizing={true}
                showBorders={true}
                columnHidingEnabled
            >
                <HeaderFilter visible />
                <Paging defaultPageSize={10} />
                <Pager
                    visible
                    showPageSizeSelector
                    allowedPageSizes={allowedPageSizes}
                />
                <FilterRow visible />
                <Column
                    dataField='originalDocRad'
                    dataType='string'
                    cellRender={renderGridCellDocRad}
                    caption={t('pages.notifications.table.columns.originalDocRad')}
                />
                <Column
                    dataField='notificationText'
                    dataType='string'
                    caption={t('pages.notifications.table.columns.notificationText')}
                />
                <Column
                    dataField='notificationDate'
                    dataType='date'
                    caption={t('pages.notifications.table.columns.notificationDate')}
                    format='dd/MM/yyyy hh:mm'
                />
                <Column
                    dataField='referenceDoc'
                    dataType='string'
                    caption={t('pages.notifications.table.columns.referenceDoc')}
                />
                <Column
                    dataField='stateDesc'
                    dataType='string'
                    caption={t('pages.notifications.table.columns.stateDesc')}
                />
            </DataGrid>
        </PagePrincipal>
    );
};
export default Notifications;